import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BsEye,
  BsEyeSlash,
  BsLock,
  BsLockFill,
  BsShieldLock,
  BsBoxArrowRight,
} from "react-icons/bs";
import logo from "../assets/EPRAJOGO1.png";
import BottomNavbar from "../components/BottomNavbar";
import {
  clearStudentSession,
  logoutStudent,
  resetPassword,
} from "../services/authService";

function Akun() {
  const navigate = useNavigate();
  const nama = localStorage.getItem("nama")?.trim() || "Siswa PKL";
  const kelas = localStorage.getItem("kelas")?.trim() || "Kelas belum diatur";
  const jurusan = localStorage.getItem("jurusan")?.trim() || "Jurusan belum diatur";
  const initials = nama
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [notice, setNotice] = useState(null);

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setNotice(null);
    const normalizedPassword = newPassword.trim();
    const normalizedConfirmation = confirmPassword.trim();

    if (!normalizedPassword || !normalizedConfirmation) {
      setNotice({ success: false, text: "Kata sandi tidak boleh kosong." });
      return;
    }
    if (normalizedPassword.length < 8) {
      setNotice({ success: false, text: "Kata sandi minimal 8 karakter." });
      return;
    }
    if (normalizedPassword !== normalizedConfirmation) {
      setNotice({ success: false, text: "Konfirmasi kata sandi tidak cocok." });
      return;
    }

    const userId = localStorage.getItem("user_id");
    if (!userId) {
      setNotice({ success: false, text: "Sesi akun tidak ditemukan. Silakan login kembali." });
      return;
    }

    setIsSaving(true);
    try {
      const result = await resetPassword(userId, normalizedPassword, normalizedConfirmation);
      if (!result.success) {
        setNotice({ success: false, text: result.message || "Gagal memperbarui kata sandi." });
        return;
      }

      clearStudentSession();
      navigate("/login", {
        replace: true,
        state: { message: result.message || "Kata sandi berhasil diperbarui. Silakan login kembali." },
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleLogout = async () => {
    if (!window.confirm("Keluar dari akun? Kamu perlu login kembali untuk memakai aplikasi.")) return;
    setIsLoggingOut(true);
    await logoutStudent();
    navigate("/login", { replace: true });
  };

  const passwordField = ({ label, value, onChange, visible, onToggle, name }) => (
    <div className="student-password-field">
      <label className="form-label" htmlFor={name}>{label}</label>
      <div className="input-group student-account-input">
        <span className="input-group-text"><BsLock /></span>
        <input
          className="form-control"
          id={name}
          name={name}
          type={visible ? "text" : "password"}
          autoComplete="new-password"
          placeholder={name === "new-password" ? "Minimal 8 karakter" : "Ulangi kata sandi baru"}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-required="true"
        />
        <button
          className="input-group-text student-password-toggle"
          type="button"
          aria-label={visible ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
          onClick={onToggle}
        >
          {visible ? <BsEyeSlash /> : <BsEye />}
        </button>
      </div>
    </div>
  );

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div>
            <p className="app-brand-name">E-PRAJOGO</p>
            <p className="app-brand-school">SMK NEGERI GUDO</p>
          </div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold student-account-badge">AKUN</span>
        </div>
        <h1 className="app-header-title">Akun Saya</h1>
        <p className="app-header-subtitle">Profil dan keamanan akun PKL-mu.</p>
      </header>

      <section className="app-content student-account-content">
        <article className="student-account-profile">
          <div className="student-account-avatar" aria-hidden="true">{initials || "S"}</div>
          <div className="student-account-identity">
            <h1>{nama}</h1>
            <p>{kelas} <span aria-hidden="true">•</span> {jurusan}</p>
            <span className="student-account-role">SISWA PKL</span>
          </div>
        </article>

        <div className="student-account-section-title">
          <span><BsShieldLock /></span>
          <div>
            <h2>Keamanan akun</h2>
            <p>Perbarui kata sandi secara berkala.</p>
          </div>
        </div>

        <form className="student-account-security" onSubmit={handleResetPassword}>
          {passwordField({
            label: "Kata sandi baru",
            name: "new-password",
            value: newPassword,
            onChange: setNewPassword,
            visible: showNewPassword,
            onToggle: () => setShowNewPassword((visible) => !visible),
          })}
          {passwordField({
            label: "Konfirmasi kata sandi",
            name: "confirm-password",
            value: confirmPassword,
            onChange: setConfirmPassword,
            visible: showConfirmPassword,
            onToggle: () => setShowConfirmPassword((visible) => !visible),
          })}

          {notice && (
            <div className={`alert ${notice.success ? "alert-success" : "alert-danger"} py-2 small mb-3`} role="status">
              {notice.text}
            </div>
          )}

          <button className="btn auth-submit student-account-save" type="submit" disabled={isSaving}>
            {isSaving ? <><span className="spinner-border spinner-border-sm me-2" />Memproses...</> : <><BsLockFill className="me-2" />Simpan kata sandi baru</>}
          </button>
          <p className="student-account-hint">Setelah kata sandi diubah, kamu akan diminta login kembali.</p>
        </form>

        <button className="btn student-account-logout" type="button" onClick={handleLogout} disabled={isLoggingOut}>
          {isLoggingOut ? <span className="spinner-border spinner-border-sm me-2" /> : <BsBoxArrowRight className="me-2" />}
          {isLoggingOut ? "Keluar..." : "Logout"}
        </button>
      </section>

      <BottomNavbar />
    </main>
  );
}

export default Akun;
